import PropTypes from 'prop-types';
import React from 'react';
import { subregionForecastPath } from '../../utils/urls';
import MetaTags from '../MetaTags';

const title = subregionName =>
  `17-Day ${subregionName} Surf Forecast for Waves, Wind & Tides - Surfline`;
const description = subregionName =>
  `The most accurate and trusted ${subregionName} surf reports, forecasts, and coastal weather. Surfers from around the world choose Surfline for daily forecasts and timely news.`;
const urlPath = (subregionId, subregionName) => subregionForecastPath(subregionId, subregionName);

const RegionalForecastMeta = ({ subregionId, subregionName }) => (
  <MetaTags
    title={title(subregionName)}
    description={description(subregionName)}
    urlPath={urlPath(subregionId, subregionName)}
  />
);

RegionalForecastMeta.propTypes = {
  subregionId: PropTypes.string.isRequired,
  subregionName: PropTypes.string.isRequired,
};

export default RegionalForecastMeta;
